import { useState } from 'react';
import { Box, Paper, Button, Grid } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import DoneIcon from '@mui/icons-material/Done';
import { useTranslation } from 'react-i18next';
import { SttFormText } from '../../../sporttia/all';
import { formatPriceByLocale } from '../../../lib/utils';

export default function BookingSectionPrice({
    price,
    sc,
    onChangePrice,
    modify = false,
}: any) {
    const { t } = useTranslation();
    const [updating, setUpdating] = useState(false);
    const [editValue, setEditValue] = useState('');

    // -----| Render |-----
    return (
        <Box mt={3}>
            <Grid container spacing={3}>
                <Grid size={{ md: 4, sm: 5, xs: 12 }}>
                    <Paper
                        style={{
                            backgroundColor: '#3e9cfd',
                            color: 'white',
                        }}
                    >
                        <Box py={3} sx={{ textAlign: 'center' }}>
                            <Box mb={2}>{t('booking.finalPriceToPay')}</Box>

                            {updating ? (
                                <Box style={{ width: 100 }}>
                                    <SttFormText
                                        defVal={editValue}
                                        onChange={({ value }: any) =>
                                            setEditValue(value)
                                        }
                                    />

                                    <Box mt={1}>
                                        <Button
                                            size="small"
                                            startIcon={<DoneIcon />}
                                            onClick={() => {
                                                // Validate on save, not on each
                                                // keystroke, so values such as
                                                // "0,50" can be typed.
                                                const accepted =
                                                    onChangePrice?.(editValue);
                                                if (accepted !== false) {
                                                    setUpdating(false);
                                                }
                                            }}
                                        >
                                            {t('general.save')}
                                        </Button>
                                    </Box>
                                </Box>
                            ) : (
                                <Box sx={{ textAlign: 'center' }}>
                                    <Box p={0} style={{ fontSize: 30 }}>
                                        {formatPriceByLocale(
                                            price,
                                            sc.city?.country?.currency,
                                            (
                                                sc.city?.country as {
                                                    locale?: string;
                                                }
                                            )?.locale,
                                        )}
                                    </Box>

                                    {modify && (
                                        <Button
                                            size="small"
                                            startIcon={<CreateIcon />}
                                            onClick={() => {
                                                setEditValue(
                                                    String(price ?? ''),
                                                );
                                                setUpdating(true);
                                            }}
                                        >
                                            {t('general.modify')}
                                        </Button>
                                    )}
                                </Box>
                            )}
                        </Box>
                    </Paper>
                </Grid>

                <Grid size={{ md: 8, sm: 7, xs: 12 }}>
                    <p>
                        <b>{t('booking.sellingPolicyTitle')}</b>
                    </p>
                    <p>
                        {[
                            sc.name,
                            sc?.customer?.cif,
                            sc.address,
                            sc.city?.name,
                            sc.city?.province?.name,
                            sc.city?.country?.name,
                        ]
                            .filter(Boolean)
                            .join(', ')}
                    </p>
                    <Box>
                        {sc.salesPolicy || t('booking.sellingPolicyDesc')}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
